import { React, useEffect, useState, useCallback } from 'react';
import { Stack, Form, Image, Pagination, Spinner } from 'react-bootstrap';
import * as api from 'services/api';
import _ from 'lodash';
import './InterventionList.css';
import { useTranslation } from 'react-i18next';
import { formattedDate } from '../../../_helpers/formatDate';
import {InterventionSearch} from '../InterventionSearch/InterventionSearch';
export function InterventionList() {
    const { t } = useTranslation();
    const [interventions, setInterventions] = useState([]);
    const [buttonsDisabled, setButtonsDisabled] = useState(false);
    const [requInterventions, setRequInterventions] = useState({
        sortField: "LockDate",
        sortDirection: "desc",
        userId: 0,
        niu: '',
        from: null,
        to: null,
        status: null,
        interventionTypeId: 0,
        offset: 0,
        limit: 10

    });
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        auditsPerPage: 10
    });
    const [sortParams, setSortParams] = useState({
        field: null,
        direction: 'desc'
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const [expandedRow, setExpandedRow] = useState(null);

    const toggleRow = (id) => {
        setExpandedRow(prev => (prev === id ? null : id));
    };

    const getInterventions = async (page, limit) => {

        const offset = (page - 1) * limit;

        const reqPayload = ({
            ...requInterventions,
            offset: offset,
            limit: limit,
            sortDirection: sortParams.direction,
            sortField: sortParams.field
        });

        const response = await api.getInterventions(reqPayload);

        if (response.status === 200) {
            setInterventions(response.data.interventions);
            console.log(response);
            setPagination(prevPagination => ({
                ...prevPagination,
                totalPages: Math.ceil(response.data.totalCount / limit)
            }));
        } else {
            console.error('Error al obtener el listado de usuarios');
        }
    };

    useEffect(() => {
        getInterventions(pagination.currentPage, pagination.auditsPerPage);
    }, [pagination.currentPage, pagination.auditsPerPage, sortParams]);

    const handlePageChange = (page) => {

        setPagination(prevPagination => ({
            ...prevPagination,
            currentPage: page
        }));
    };

    const handlePerPageChange = (e) => {
        const perPage = parseInt(e.target.value);
        setPagination(prevPagination => ({
            ...prevPagination,
            currentPage: 1,
            auditsPerPage: perPage
        }));
    };

    const handleSort = (field) => {
        if (sortParams.field === field) {
            setSortParams(prevSortParams => ({
                ...prevSortParams,
                direction: prevSortParams.direction === "asc" ? "desc" : "asc"
            }));
        } else {
            setSortParams({ field, direction: "asc" });
        }
    };

    useEffect(() => {
        const obtenerDatos = async () => {
            try {
                const response = await api.getInterventions(requInterventions);
                setLoading(false);
                console.log(response);
                if (response.status === 200) {
                    setInterventions(response.data.interventions);
                    setPagination(prev => ({
                        ...prev,
                        totalPages: Math.ceil(response.data.totalCount / pagination.auditsPerPage)
                    }));
                } else {
                    setError(t('noResultsFound'));
                }
            } catch (error) {
                setLoading(false);
                setError(t('noResultsFound'));
            }
        }
        obtenerDatos();
    }, [requInterventions]);

    const handleSearch = async (filters) => {
        setLoading(true);

        setRequInterventions({
            sortField: "LockDate",
            sortDirection: "desc",
            interventionTypeId: filters.interventionTypeId,
            status: filters.status,
            from: filters.from,
            to: filters.to,
            offset: 0,
            limit: pagination.auditsPerPage
        });

        setPagination({
            currentPage: 1,
            totalPages: 1,
            auditsPerPage: 10
        });
    };

    const handleRetry = async (intervention) => {
        setButtonsDisabled(true);

        try {
            const dataToSend = {
                username: intervention.user.username,
                action: intervention.interventionType.integrationId,
                pseudocodes: intervention.pseudocodes.filter(p => p.status === true),
                dwellingId: parseInt(intervention.niu, 10),
                interventionId: intervention.id
            };

            const responseIntegration = await api.integration(dataToSend);
            console.log(responseIntegration);

            let dataToRetry = { ...intervention };

            if (responseIntegration.status === 200) {
                dataToRetry = {
                    ...intervention,
                    integrationId: responseIntegration.data.id
                };
            } 

            const responseIntervention = await api.retryIntervention(dataToRetry);
            console.log(responseIntervention);

            getInterventions(pagination.currentPage, pagination.auditsPerPage);
        }
        finally {
            setButtonsDisabled(false); // Reactiva los botones al terminar
        }
    };

    return (
        <div className="AuditsList">

            <div className="d-block">

                <InterventionSearch handleSearch={handleSearch} />
                {loading && (
                    <Spinner animation="border" variant="secondary" size="sm" className="AuditsList__spinner" />
                )}
                <Stack direction="horizontal" className="justify-content-start">
                    {error && <p className="text-danger fw-semibold">{error}</p>}
                </Stack>
            </div>

            {interventions.length > 0 && (
                <div className="card rounded-3 overflow-auto mt-2 p-2">
                    <table hover size="sm" className='table table-hover overflow-auto'>
                        <thead>
                            <tr style={{ fontSize: '15px' }}>
                                <th style={{ width: '5%' }}>&nbsp;</th>
                                <th style={{ width: '10%' }} onClick={() => handleSort('Niu')}>{t('int.Niu')}</th>
                                <th style={{ width: '20%' }} onClick={() => handleSort('User')}>{t('int.Username')}</th>
                                <th style={{ width: '30%' }} onClick={() => handleSort('InterventionType')}>{t('int.Type')}</th>
                                <th style={{ width: '20%' }} onClick={() => handleSort('LockDate')}>{t('int.LockDate')}</th>
                                <th style={{ width: '20%' }} onClick={() => handleSort('Status')}>{t('int.Status')}</th>
                                <th></th>

                            </tr>
                        </thead>
                        <tbody>
                            {interventions.map((intervention) => {
                                const isExpanded = expandedRow === intervention.id;
                                const hasEnabled = intervention.pseudocodes.some(p => p.status);

                                return (
                                    <>
                                        <tr key={intervention.id}
                                            role='button'
                                            className={isExpanded ? 'table-active selected-row' : ''}
                                            onClick={() => toggleRow(intervention.id)}
                                        >
                                            <td className="align-middle">
                                                <button className="btn btn-sm btn-link" >
                                                    {isExpanded ? t('int.HideDetails') : t('int.ShowDetails')}
                                                </button>
                                            </td>
                                            <td className="align-middle"> {intervention.niu} </td>
                                            <td className="align-middle">{intervention.user.username}</td>
                                            <td className="align-middle">{intervention.interventionType.name}</td>
                                            <td className="align-middle"> {formattedDate(intervention.lockDate, "dd/MMM HH:mm")} </td>
                                            <td className="align-middle">{t('int.status_'+intervention.status)}</td>
                                            <td>
                                                {(hasEnabled && intervention.status < 3 && new Date(intervention.unlockDate) < new Date() && (!intervention.integration || intervention.integration.id === 0)) ? (
                                                    <button className="btn btn-warning w-80" onClick={() => handleRetry(intervention)} disabled={buttonsDisabled}>{t('int.Retry')}</button>
                                            ):(intervention.integration && intervention.integration.errorMensaje !== '') && (
                                                        <span><Image src="./icons/alert.svg" className="UsersList__image" /></span>
                                                )}
                                            </td>
                                        </tr>

                                        {isExpanded && (
                                            <tr>
                                                <td colSpan={7}>
                                                    <div className="p-2 bg-light border rounded">
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <p><strong>{t('int.UnlockHour')}:</strong> {formattedDate(intervention.unlockDate, "HH:mm")}</p>
                                                                <p><strong>{t('int.Pseudocodes')}:</strong></p>
                                                                {intervention.pseudocodes.map((pseudocode, idx) => (
                                                                    <p>
                                                                        {pseudocode.pseudocode}
                                                                        {pseudocode.status === true ? (< Image src="./icons/check.svg" className="AuditsList__image" />) : (< Image src="./icons/x.svg" className="AuditsList__image" />)}
                                                                    </p>
                                                                ))}
                                                            </div>

                                                            <div className="col-md-4">
                                                                <p><strong>{t('int.Status')}:</strong> <span style={{ color: intervention.status === 1 ? 'red' : 'green' }}>{t('int.status_' + intervention.status)}</span></p>
                                                                <p><strong>{t('int.End')}:</strong> {formattedDate(intervention.endDate, "HH:mm")}</p>
                                                                {intervention.retryUser && (
                                                                    <>
                                                                        <p><strong>{t('int.RetryUser')}:</strong> {intervention.retryUser?.username}</p>
                                                                        <p><strong>{t('int.RetryDate')}:</strong> {formattedDate(intervention.retryDate, "dd/MMM HH:mm")}</p>
                                                                    </>
                                                                )}
                                                            </div>

                                                            <div className="col-md-4">
                                                                {intervention.integration.id > 0 && (
                                                                    <p><strong>{t('int.IntegrationStatus')}:</strong> {intervention.integration.estado}</p>
                                                                )}
                                                                {intervention.integration.errorMensaje !== "" && (
                                                                    <p style={{ color: 'red' }}><strong>{t('int.IntegrationError')}:</strong> {intervention.integration.errorMensaje}</p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                );
                            })}
                        </tbody>
                    </table>
                    <Pagination size="sm" className="AuditsList__pagination">
                        <div className="AuditsList__paginationText">{t('auRowsPerPage')}</div>
                        <Form.Select aria-label="Filas por página" size="sm" className="AuditsList__paginationSelect" value={pagination.auditsPerPage} onChange={handlePerPageChange}>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={30}>30</option>
                            <option value={40}>40</option>
                            <option value={50}>50</option>
                        </Form.Select>
                        <div className="AuditsList__paginationText">{t('pPage')} {pagination.currentPage} {t('pFrom')} {pagination.totalPages}</div>
                        <Pagination.First onClick={() => handlePageChange(1)} disabled={pagination.currentPage === 1} />
                        <Pagination.Prev onClick={() => handlePageChange(pagination.currentPage - 1)} disabled={pagination.currentPage === 1} />
                        <Pagination.Next onClick={() => handlePageChange(pagination.currentPage + 1)} disabled={pagination.currentPage === pagination.totalPages} />
                        <Pagination.Last onClick={() => handlePageChange(pagination.totalPages)} disabled={pagination.currentPage === pagination.totalPages} />
                    </Pagination>
                </div>
            )}
        </div>
    );
}